// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b55c778a","453":"2574f156","455":"0dab05c8"}[chunkId] + ".chunk.js";
};